// extracted by mini-css-extract-plugin
export var closeButton = "_fc-2";
export var closeButtonIcon = "_fc-3";
export var lightboxContent = "_fc-1";
export var lightboxOverlay = "_fc-0";